export const imgUrl = 'https://d49qdhygt0dif.cloudfront.net';
export const url = process.env.REACT_APP_BASE_URL;

